function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import SiteActivityTabs from "../../components/site-activity-tabs";
import { withRouter } from "react-router";
import { SimpleContainer, CssContainer } from "../../components/container";
import { ActivityContainer, ActivityTrendsHeader, ActivityData } from "../../components/container-activity";
import { KpiStrip, Kpi } from '../../components/card';
import { Loader, EllipsisLoader } from '../../components/loaders';
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import Error from '../../components/error';
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import ActivityLocationGrid from "../../components/activity-location-grid";
import ActivityLocationPlacesGrid from "../../components/activity-location-places-grid";
import Query from '../../functions/query';
import rangeLabel from "../../functions/range-label";
import account from "../../data/account";
import ServiceFactory from '../../service';
import { getGlobalRange, getGlobalComp, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import GroupFilter from "../../components/group-filter";
import format from "../../functions/format";
import groupByLabel from "../../functions/groupBy-label";
import compLabel from "../../functions/comp-label";
import snakeToCamel from "../../functions/snake-to-camel";
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    //activity header dropdowns
    _defineProperty(this, "onSelected", e => {
      var item = e.detail.item;
      var range = item.dataset.value;
      var comp = this.comp;
      var redirectUrl = this.redirectUrl(range, comp);
      this.gotoPage(redirectUrl);
    });
    _defineProperty(this, "onCompSelected", e => {
      var item = e.detail.item;
      var range = this.range;
      var comp = item.dataset.value;
      if (comp === 'unavailable') {
        return;
      }
      this.fetchChartData = true;
      var redirectUrl = this.redirectUrl(range, comp);
      this.gotoPage(redirectUrl);
    });
    //group filter dropdowns
    _defineProperty(this, "onGroupBySelected", e => {
      var item = e.detail.item;
      var groupBy = item.dataset.value;
      var range = this.range;
      var comp = this.comp;
      this.gotoPage(`/Activity/Location/${range}/${comp}/${groupBy}`);
    });
    _defineProperty(this, "onPlacesGroupBySelected", e => {
      var item = e.detail.item;
      var groupBy = item.dataset.value;
      var range = this.range;
      var comp = this.comp;
      //this.props.history.push(`/Activity/Location/Places/${range}/${comp}/${groupBy}`);
      this.gotoPage(`/Activity/Location/Places/${range}/${comp}/${groupBy}`);
    });
    this.fetchScoreCard = false;
    this.state = {
      showLoader: true,
      data: null
    };
  }
  async componentDidMount() {
    publishSearch('Locations', true, 'locations', 'city', 'City');
    publishEvent('reset-search', {});
    await this.fetch();
    this._periodTok = subscribePeriod(({
      range,
      comp
    }) => {
      if (window.location.pathname.indexOf('/Activity/Location') !== 0) return;
      const r0 = range || getGlobalRange();
      const r = String(r0).indexOf('custom') === 0 ? 'this_month' : r0;
      const c = comp || this.comp;
      this.gotoPage(`/Activity/Location/${r}/${c}/${this.groupBy}`);
    });
  }
  componentWillUnmount() {
    unsubscribePeriod(this._periodTok);
  }
  async componentDidUpdate() {
    console.log('update');
    if (this.fetchScoreCard) {
      await this.fetch();
    }
  }
  get isPlacesView() {
    var path = location.pathname;
    path = path.toLowerCase();
    return path.includes('/places');
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange();
    if (String(range).indexOf('custom') === 0) range = 'this_month';
    return range;
  }
  get groupBy() {
    var groupBy = this.props.params.groupBy;
    if (!groupBy) groupBy = 'city';
    return groupBy;
  }
  get comp() {
    var comp = this.props.params.comp;
    if (!comp) comp = getGlobalComp();
    return comp;
  }
  get compRange() {
    var range = this.range;
    var comp = this.comp;
    if (comp === 'prev_period') {
      range += '_prev';
    }
    return range;
  }
  redirectUrl(range, comp) {
    var groupBy = this.groupBy;
    if (this.isPlacesView) {
      return `/Activity/Location/Places/${range}/${comp}/${groupBy}`;
    } else {
      return `/Activity/Location/${range}/${comp}/${groupBy}`;
    }
  }
  async fetch() {
    await this.fetchData();
  }
  async fetchData() {
    var api = '/metrics/location/scorecard';
    var Service = ServiceFactory.getType(api);
    var service = new Service();
    try {
      let data = await service.getAsync();
      console.log(data);
      this.fetchScoreCard = false;
      this.setState({
        showLoader: false,
        data: data
      });
    } catch (err) {}
  }
  render() {
    var range = this.range;
    var comp = this.comp;
    var groupBy = this.groupBy;
    var groupByColumn = snakeToCamel(groupBy);
    var selection = rangeLabel(range);
    var groupLabel = groupByLabel(groupBy);
    var refreshUrl = '/Activity/Location/all_time/prev_year/city';
    var baseUrl = `/Activity/Location/${range}/${comp}/${groupBy}`;
    var placesRefreshUrl = '/Activity/Location/all_time/prev_year/city';
    var placesBaseUrl = `/Activity/Location/Places/${range}/${comp}/${groupBy}`;
    var scorecard = this.state.data;
    var accountData = account.get();
    var domain = accountData.domain;
    var selection = rangeLabel(range);
    var groupLabel = groupByLabel(groupBy);
    var compSelection = compLabel(this.comp);
    var compHide = range === 'all_time';
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SiteActivityTabs, null), /*#__PURE__*/React.createElement(ActivityContainer, {
      cls: "stacked order-1"
    }, /*#__PURE__*/React.createElement(ActivityTrendsHeader, {
      title: "Locations",
      hideControls: true,
      selection: selection,
      id: "locations",
      onSelected: this.onSelected,
      compId: "locations-comp",
      onCompSelected: this.onCompSelected,
      compSelection: compSelection,
      comp: this.comp,
      range: range,
      compHide: compHide
    }), this.state.showLoader ? /*#__PURE__*/React.createElement(EllipsisLoader, {
      cls: "loader-container auto"
    }) : /*#__PURE__*/React.createElement(ActivityData, null, /*#__PURE__*/React.createElement(KpiStrip, null, /*#__PURE__*/React.createElement(Kpi, {
      label: "Locations",
      value: format(scorecard.count, '-', 0, '')
    }), /*#__PURE__*/React.createElement(Kpi, {
      label: "Markets",
      value: format(scorecard.placesCount, '-', 0, '')
    })))), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GroupFilter, {
      id: "groupBy-filter-1",
      name: "Locations: ",
      color: "purple",
      selection: groupLabel,
      onSelected: this.onGroupBySelected
    }))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityLocationGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: this.props.data,
      comparison: this.props.comparison,
      range: range,
      column: groupByColumn,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest
    })), /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GroupFilter, {
      id: "groupBy-filter-2",
      name: "Markets: ",
      color: "orange",
      selection: groupLabel,
      onSelected: this.onPlacesGroupBySelected
    }))), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ActivityLocationPlacesGrid, {
      refreshUrl: placesRefreshUrl,
      baseUrl: placesBaseUrl,
      data: this.props.placesData,
      pagination: this.props.placesPagination,
      range: range,
      domain: domain,
      column: groupByColumn,
      comparison: this.props.placesComparison,
      onPageRequest: this.onPageRequest
    })));
  }
}
export class ActivityLocationViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  get isPlacesView() {
    var path = location.pathname;
    path = path.toLowerCase();
    return path.includes('/places');
  }
  get defaultPage() {
    var isPlacesView = this.isPlacesView;
    if (!isPlacesView) return this.page;else return 1;
  }
  get placesPage() {
    var isPlacesView = this.isPlacesView;
    if (isPlacesView) return this.page;else return 1;
  }
  get range() {
    var range = this.props.params.range;
    if (!range) range = getGlobalRange();
    if (String(range).indexOf('custom') === 0) range = 'this_month';
    return range;
  }
  get groupBy() {
    var groupBy = this.props.params.groupBy;
    if (!groupBy) groupBy = 'city';
    return groupBy;
  }
  get comp() {
    var comp = this.props.params.comp;
    if (!comp) comp = getGlobalComp();
    return comp;
  }
  get compRange() {
    var range = this.range;
    var comp = this.comp;
    if (comp === 'prev_period') {
      range += '_prev';
    }
    return range;
  }

  //apis use range and groupBy
  get api() {
    var range = this.range;
    var groupBy = this.groupBy;
    var api = `/metrics/location/${range}/${groupBy}`;
    var where = this.where;
    if (!this.isPlacesView && where) {
      api += '?$where=' + where;
    }
    return api;
  }
  get placesApi() {
    var range = this.range;
    var groupBy = this.groupBy;
    var api = `/metrics/place/${range}/${groupBy}`;
    var where = this.where;
    if (this.isPlacesView && where) {
      api += '?$where=' + where;
    }
    return api;
  }
  //comparison apis use compRange, groupBy
  get comparisonApi() {
    var compRange = this.compRange;
    var groupBy = this.groupBy;
    var api = `/metrics/trends/location-stats/${compRange}/${groupBy}`;
    return api;
  }
  get comparisonPlacesApi() {
    var compRange = this.compRange;
    var groupBy = this.groupBy;
    var api = `/metrics/trends/place-stats/${compRange}/${groupBy}`;
    return api;
  }
  //base Urls use range/comp/groupBy
  get baseUrl() {
    var range = this.range;
    var groupBy = this.groupBy;
    var comp = this.comp;
    var baseUrl = `/Activity/Location/${range}/${comp}/${groupBy}`;
    return baseUrl;
  }
  get placesBaseUrl() {
    var range = this.range;
    var groupBy = this.groupBy;
    var comp = this.comp;
    var baseUrl = `/Activity/Location/Places/${range}/${comp}/${groupBy}`;
    return baseUrl;
  }
  get orderBy() {
    let query = this.queryParams;
    let orderBy = query.get('$orderBy');
    return orderBy;
  }
  get orderByDesc() {
    let query = this.queryParams;
    let orderBy = query.get('$orderBy');
    let orderByDesc = query.get('$orderByDesc');
    if (!orderBy && !orderByDesc) {
      orderByDesc = 'Views';
    }
    return orderByDesc;
  }
  get defaultOrderBy() {
    if (!this.isPlacesView) {
      return this.orderBy;
    } else {
      return null;
    }
  }
  get defaultOrderByDesc() {
    if (!this.isPlacesView) {
      return this.orderByDesc;
    } else {
      return 'Views';
    }
  }
  get placesOrderBy() {
    if (this.isPlacesView) {
      return this.orderBy;
    } else {
      return null;
    }
  }
  get placesOrderByDesc() {
    if (this.isPlacesView) {
      return this.orderByDesc;
    } else {
      return 'Views';
    }
  }
  get where() {
    let query = this.queryParams;
    let where = query.get('$where');
    return where;
  }
  async fetchData() {
    var groupBy = this.groupBy;
    let page = this.defaultPage;
    let placesPage = this.placesPage;
    var api = this.api;
    var placesApi = this.placesApi;
    var comparisonApi = this.comparisonApi;
    var comparisonPlacesApi = this.comparisonPlacesApi;
    var Service = ServiceFactory.getType(api);
    var PlacesService = ServiceFactory.getType(placesApi);
    var ComparisonService = ServiceFactory.getType(comparisonApi);
    var PlacesComparisonService = ServiceFactory.getType(comparisonPlacesApi);
    var service = new Service();
    var placesService = new PlacesService();
    var comparisonService = new ComparisonService();
    var placesComparisonService = new PlacesComparisonService();
    var baseUrl = this.baseUrl;
    var placesBaseUrl = this.placesBaseUrl;
    var defaultOrderBy = this.defaultOrderBy;
    var defaultOrderByDesc = this.defaultOrderByDesc;
    var placesOrderBy = this.pagesLocationOrderBy;
    var placesOrderByDesc = this.pagesLocationOrderByDesc;
    var groupByColumn = snakeToCamel(groupBy);
    try {
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: 10
      }).orderBy(defaultOrderBy).orderByDesc(defaultOrderByDesc).getAsync();
      console.log(data);
      let placesData = await placesService.paginate({
        baseUrl: placesBaseUrl,
        rawUrl: location.href,
        page: placesPage,
        pageSize: 10
      }).orderBy(placesOrderBy).orderByDesc(placesOrderByDesc).getAsync();
      console.log(placesData);
      let comparison = [];
      let placesComparison = [];
      if (this.range !== 'all_time') {
        let locationColumnValues = data.items.map(a => a[groupBy]);
        comparison = await comparisonService.postAsync(locationColumnValues);
        comparison.sort((a, b) => {
          return locationColumnValues.findIndex(x => x === a[groupByColumn]) - locationColumnValues.findIndex(x => x === b[groupByColumn]);
        });
        let placesColumnValues = placesData.items.map(a => a[groupByColumn]);
        placesComparison = await placesComparisonService.postAsync(placesColumnValues);
        placesComparison.sort((a, b) => {
          return placesColumnValues.findIndex(x => x === a[groupByColumn]) - placesColumnValues.findIndex(x => x === b[groupByColumn]);
        });
        console.log(placesColumnValues);
      }
      this.data = data.items;
      this.pagination = data.pagination;
      this.placesData = placesData.items;
      this.placesPagination = placesData.pagination;
      this.comparison = comparison;
      this.placesComparison = placesComparison;
      this.allowUpdate = false;
      this.allowRender = true;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        placesData: this.placesData,
        placesPagination: this.placesPagination,
        comparison: this.comparison,
        placesComparison: this.placesComparison,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ActivityLocationViewComponent
};